window.ValetElevatorModal = {

    init() {

        this.modal = document.querySelector(
            "[data-valet-elevator-modal]"
        );

        if (!this.modal) return;

        this.productId =
            this.modal.dataset.elevatorProductId || "";

        this.variantId =
            this.modal.dataset.elevatorVariantId || "";

        this.checkbox = this.modal.querySelector(
            "[data-elevator-agree]"
        );

        this.confirm = this.modal.querySelector(
            "[data-elevator-confirm]"
        );

        this.cancel = this.modal.querySelector(
            "[data-elevator-cancel]"
        );

        this.overlay = this.modal.querySelector(
            "[data-modal-close]"
        );

        this.bind();

    },

    bind() {

        this.checkbox.addEventListener("change", () => {

            this.confirm.disabled =
                !this.checkbox.checked;

        });

        this.confirm.addEventListener("click", () => {

            const booking = window.valetBooking;

            if (!booking) return;

            if (booking.address.elevator === "No") {

                booking.elevatorCharge.enabled = true;

                booking.elevatorCharge.productId = this.productId;
                booking.elevatorCharge.variantId = this.variantId;

                booking.elevatorCharge.title =
                    this.modal.dataset.elevatorTitle;

                booking.elevatorCharge.price =
                    this.modal.dataset.elevatorPrice;

                booking.elevatorCharge.rawPrice =
                    Number(this.modal.dataset.elevatorPriceRaw);

            } else {

                booking.elevatorCharge = {

                    enabled: false,
                    productId: "",
                    variantId: "",
                    title: "",
                    price: "",
                    rawPrice: 0

                };

            }

            console.log("Elevator Charge:", booking.elevatorCharge);

            if (window.exxtraBookingSummary) {

                window.exxtraBookingSummary
                    .updateElevatorCharge();

            }

            document.dispatchEvent(
                new CustomEvent("valet:elevator-confirmed")
            );

            this.close();

        });
        this.cancel.addEventListener("click", () => {

            this.close();

        });

        this.overlay.addEventListener("click", () => {

            this.close();

        });

    },

    open() {

        console.log("Before:", this.modal.hidden);

        this.checkbox.checked = false;

        this.confirm.disabled = true;

        this.modal.hidden = false;

        console.log("After:", this.modal.hidden);

        console.log(this.modal);

        document.body.classList.add(
            "valet-modal-open"
        );

    },
    close() {

        this.modal.hidden = true;

        document.body.classList.remove(
            "valet-modal-open"
        );

    }

};

document.addEventListener("DOMContentLoaded", () => {

    window.ValetElevatorModal.init();

});